@if (products().length <= maxProducts) {
    <div [class.product-table-disabled]="disabled()">
        <ag-grid-angular
            class="w-full"
            [domLayout]="'autoHeight'"
            [popupParent]="popupParent"
            [rowData]="rowData()"
            [columnDefs]="columnDefs()"
            [defaultColDef]="defaultColDef"
            [cellSelection]="cellSelection()"
            [localeText]="localeText()"
            [stopEditingWhenCellsLoseFocus]="true"
            [tooltipShowDelay]="200"
            [getRowId]="getRowId"
            [autoSizeStrategy]="autoSizeStrategy"
            (gridReady)="onGridReady($event)"
            (firstDataRendered)="onFirstDataRendered()"
            (cellValueChanged)="onCellValueChanged($event)"
            (cellEditingStopped)="onCellEditingStopped($event)"
        />
    </div>
} @else {
    <p class="text-sm text-light-textColorSecondary dark:text-dark-textColorSecondary">
        {{ 'product-table.limited-display' | translate: { displayed: maxProducts, total: products().length } }}
    </p>
}
